import Reveal from "../../Reveal";
import Eyebrow from "../../Eyebrow";
import { logoRegistry } from "../../../../assets/logoRegistry";
import { kanziSections } from "../../../../content/kanziSections";

const TeamBackgrounds = () => {
  const { credibility } = kanziSections;
  const marqueeLogos = [...credibility.teamLogos, ...credibility.teamLogos];

  return (
    <section id="about" className="section-block section-block--flush-top">
      <div className="section-shell">
        <Reveal>
          <Eyebrow className="kanzi-credibility__team-label">{credibility.teamLabel}</Eyebrow>
          <p className="kanzi-credibility__team-desc">{credibility.teamDescription}</p>
        </Reveal>

        <div className="logo-slider-container kanzi-credibility__marquee">
          <div className="logo-marquee">
            {marqueeLogos.map((logo, index) => (
              <div key={`${logo.key}-${index}`} className="logo-item">
                <img
                  src={logoRegistry[logo.key].src}
                  className="logo-item__image"
                  alt={logoRegistry[logo.key].alt}
                  title={`Team experience with ${logoRegistry[logo.key].alt}`}
                  width="640"
                  height="320"
                  style={{
                    "--logo-mobile-height": `${logoRegistry[logo.key].mobileHeight}px`,
                    "--logo-desktop-height": `${logoRegistry[logo.key].desktopHeight}px`,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamBackgrounds;
